const lang = {
    cancel: '取消',
    close: '关闭',
    ok: '确定',
    country: {
        china: '中国',
        hongKong: '中国香港',
        macau: '中国澳门',
        taiwan: '中国台湾',
        singapore: '新加坡',
        malaysia: '马来西亚',
        indonesia: '印度尼西亚',
        thailand: '泰国',
        philippines: '菲律宾',
        vietnam: '越南',
        myanmar: '缅甸'
    },
    friendlyTime: {
        just: '刚刚',
        yesterday: '昨天',
        oneMinuteAgo: '1分钟前',
        minutesAgo: '分钟前',
        oneHourAgo: '1小时前',
        hoursAgo: '小时前',
        daysAgo: '天前',
        weeksAgo: '周前',
    },
    loading: '加载中…',
    page: {
        loadMore: '加载更多',
        loading: '正在加载',
        noMore: '没有更多数据了'
    },
    empty: {
        noData: '暂无数据',
        noAttention: '暂无关注',
        noNetwork: '暂无网络',
        theServerIsWrong: '服务器出错了',
        underConstructionAndWorkingHardToMaintain: '正在建设中、正在努力维护中',
        pleaseWaitPatientlyForCertificationAndReview: '认证、审核请耐心等待',
        searchNoResults: '搜索无结果',
    },
    selectMember: {
        all: '全部',
        title: '选择人员',
        titleRange: '选择范围',
        selected:'已选择',
        search: '搜索',
        clear:'清空',
        cancel:'取消',
        ok:'确定',
        dept:'组织',
        deptMember:'组织成员',
        group:'内部群',
        groupMember:'内部群成员',
        team:'组',
        teamMember:'组内成员',
        member:'成员',
        includingSubordinate: '包含下级',
        cancelSubordinate: '取消下级',
        publicTeam: '公共组',
        privateTeam: '个人组',
        maximum: '已超出最大限制'
    }
}

export default lang



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js